
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinpune() {



    const cardData =
    {
        keyword: ' Corporate cab service in Pune',
        heading: 'S9 Travels:  Corporate cab service in Pune',
        headingDescription: 'S9 Travels offers premium Corporate Cab Services in Pune for a smooth and professional travel experience. Whether you are heading to an important business meeting, corporate event, or need reliable transportation for your team, our fleet of well-maintained cabs ensures timely and comfortable travel. With spacious interiors, luxury features, and a punctual service, you can focus on your work while we handle the rest. Our professional drivers are trained to provide a safe, efficient, and hassle-free experience, making S9 Travels the ideal choice for all your corporate travel needs in Pune.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada is a must-see for history buffs. This grand palace was once the seat of the Peshwa rulers and offers fascinating glimpses into Pune's royal past. The light and sound show in the evening is a popular attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892, this beautiful palace is known for its historical significance, as it served as a prison for Mahatma Gandhi during the Indian independence struggle. The palace is surrounded by lush gardens and serves as a reminder of India’s freedom movement."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located on a hilltop, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. A popular trekking destination, it is also rich in history, having been the site of many battles, including the famous Battle of Sinhagad."
    },
    {
      "title": "Osho Ashram",
      "description": "For those seeking peace and tranquility, the Osho Ashram in Pune is a renowned spiritual retreat. It offers yoga, meditation, and spiritual practices to rejuvenate your mind and body. It’s an ideal place for those looking for a calm and reflective experience."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This ancient rock-cut temple, dedicated to Lord Shiva, is located right in the heart of Pune. Carved out of a single rock, it is a serene and historical place, providing insight into ancient Indian architecture and religion."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses a wide collection of artifacts, including sculptures, paintings, and other cultural exhibits. It showcases the rich artistic heritage of India, with a special emphasis on Maharashtra's traditional art forms."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "For nature lovers and those looking for a peaceful escape, Khadakwasla Dam offers a scenic location to relax. It’s a popular spot for picnics, and you can enjoy the beauty of the surrounding hills and the cool breeze by the water."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known as the heart of Pune's youthful and energetic vibe, Fergusson College Road is a bustling area filled with cafes, bookshops, and vibrant street markets. It’s a great spot to experience Pune’s lively culture and shop for souvenirs."
    },
    {
      "title": "Lal Mahal",
      "description": "A significant historical landmark, Lal Mahal was the residence of Chhatrapati Shivaji Maharaj during his youth. It’s an important monument that offers insights into the life of the great Maratha king."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully landscaped park is a peaceful retreat with lovely walking paths, koi ponds, and traditional Japanese architecture. It's an ideal place for a serene walk or a family outing."
    }
],

"services": [
    {
      "name": "Corporate Cab Service in Pune",
      "description": "Looking for reliable transportation for your business needs in Pune? Our corporate cab service provides punctual and comfortable rides for your team, ensuring smooth travel for meetings, events, and more. Choose S9 Travels for hassle-free corporate transportation."
    },
    {
      "name": "Book Corporate Cabs for Businesses",
      "description": "Booking corporate cabs for your business is easy with S9 Travels. Whether it’s for a team outing, client meetings, or daily office commutes, we offer professional taxi services that ensure comfort, reliability, and efficiency for your corporate needs."
    },
    {
      "name": "Monthly Cab Service in Pune for Corporate Needs",
      "description": "Looking for a monthly cab service for your business in Pune? S9 Travels offers flexible monthly cab packages tailored to your corporate requirements. Enjoy consistent, reliable transport for employees or executives, with the convenience of fixed pricing."
    },
    {
      "name": "Affordable Corporate Cab Service in Pune",
      "description": "Need an affordable corporate cab service in Pune? S9 Travels offers the best value for businesses seeking reliable transportation without breaking the bank. We provide cost-effective options for companies of all sizes, ensuring comfort and professionalism."
    },
    {
      "name": "Corporate Transport Solutions",
      "description": "S9 Travels provides tailored corporate transport solutions in Pune. Whether it's a one-time trip or an ongoing need, we ensure that your employees and clients travel comfortably and punctually, with a variety of vehicles to meet your specific requirements."
    },
    {
      "name": "Book Cabs for Corporate Events in Pune",
      "description": "Planning a corporate event in Pune? Let S9 Travels handle your transportation needs. Book cabs for your event and ensure all guests, employees, or clients travel in comfort. We offer flexible booking options for seamless transport to conferences, seminars, and more."
    },
    {
      "name": "Pune Corporate Office Cab Service",
      "description": "S9 Travels offers corporate office cab services in Pune to ensure timely and efficient transportation for your staff. Whether it's a daily commute or occasional pick-up and drop-off, we offer a reliable and professional service tailored to office transportation."
    },
    {
      "name": "Executive Taxi Service for Corporate Offices",
      "description": "Our executive taxi service caters to high-level professionals and corporate offices in Pune. With a fleet of well-maintained, luxury vehicles, we offer an executive travel experience to ensure your executives are always on time and in comfort."
    },
    {
      "name": "Office Transportation in Pune",
      "description": "S9 Travels offers comprehensive office transportation services in Pune. Whether you're arranging for daily commutes, meetings, or corporate outings, our reliable service ensures that your employees travel efficiently and comfortably."
    },
    {
      "name": "Corporate Group Travel in Pune",
      "description": "For corporate group travel, S9 Travels provides spacious and comfortable transportation solutions. Whether you're organizing a team retreat, business conference, or group event, our vehicles can accommodate your team, ensuring smooth and comfortable travel throughout Pune."
    },
    {
      "name": "Pune Corporate Transportation Providers",
      "description": "As trusted corporate transportation providers in Pune, S9 Travels ensures professional and reliable service for businesses. Whether you're organizing a corporate event, employee transport, or client pick-ups, we offer tailored solutions to meet your corporate transportation needs."
    },
    {
      "name": "Business Travel Cabs in Pune",
      "description": "S9 Travels offers business travel cabs in Pune for professionals who need reliable, timely, and comfortable transport. Whether you're attending a business meeting, conference, or client visit, our cabs ensure you arrive on time and in comfort."
    },
    {
      "name": "Affordable Business Taxi Services",
      "description": "S9 Travels offers affordable business taxi services in Pune, giving you the best balance of cost-effectiveness and comfort. Perfect for daily commutes or special business trips, our taxis are reliable and easy to book."
    },
    {
      "name": "Executive Chauffeur Services in Pune",
      "description": "For those who need a higher level of service, S9 Travels provides executive chauffeur services in Pune. Our professional chauffeurs ensure your business travel is as smooth and luxurious as possible, whether for meetings, events, or daily commutes."
    }
],

"tableData": [
  ["Corporate Cab Service in Pune", "Book Corporate Cabs for Businesses"],
  ["Monthly Cab Service in Pune for Corporate Needs", "Affordable Corporate Cab Service in Pune"],
  ["Corporate Transport Solutions", "Book Cabs for Corporate Events in Pune"],
  ["Pune Corporate Office Cab Service", "Executive Taxi Service for Corporate Offices"],
  ["Office Transportation in Pune", "Corporate Group Travel in Pune"],
  ["Pune Corporate Transportation Providers", "Business Travel Cabs in Pune"],
  ["Affordable Business Taxi Services", "Executive Chauffeur Services in Pune"],
  ["", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Punctual and Professional Service",
    "WhyChoosedescription": "At S9 Travels, we understand that time is crucial for business professionals. Our corporate cab service in Pune guarantees punctual pick-ups and drop-offs, ensuring that you never miss an important meeting or event. Our drivers are always on time and professional in their approach."
  },
  {
    "WhyChooseheading": "Luxury and Comfort for Business Travel",
    "WhyChoosedescription": "We provide a fleet of luxury vehicles, including the Toyota Innova, for your corporate travel needs. With spacious seating, air conditioning, and a smooth ride, our cabs ensure that you arrive at your destination in comfort and style, ready for any business engagement."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs for Seamless Travel",
    "WhyChoosedescription": "Our team of experienced and professional chauffeurs is well-versed with the routes in Pune and surrounding areas. They prioritize safety, comfort, and efficiency, ensuring your business journey is as smooth as possible, whether it’s a short trip or a long-distance ride."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "S9 Travels offers corporate cab services with clear and competitive pricing. We provide transparent cost breakdowns during the booking process, ensuring there are no hidden charges. Our pricing models are designed to offer the best value for your corporate travel needs."
  },
  {
    "WhyChooseheading": "Reliable and Secure Travel Options",
    "WhyChoosedescription": "Safety is a top priority at S9 Travels. Our corporate cabs are equipped with advanced safety features, including GPS tracking, airbags, and seat belts. Whether you're traveling for a meeting or a corporate event, you can trust that you are in safe hands."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our corporate cab service operates 24/7, ensuring that your business travel needs are met at any hour of the day or night. Our customer service team is always available to help with bookings, modifications, or assistance with any travel-related concerns."
  },
  {
    "WhyChooseheading": "Simple and Efficient Booking Process",
    "WhyChoosedescription": "Booking a corporate cab with S9 Travels is hassle-free. You can book online through our website or mobile app or speak with our customer service team for personalized assistance. We ensure a smooth booking experience that fits your schedule."
  },
  {
    "WhyChooseheading": "Tailored Corporate Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for corporate clients, tailored to meet the specific needs of your business trips. Whether it's a conference, client meeting, or corporate retreat, we can design a package that suits your preferences and requirements."
  }
]





    }



    const faqData = [
        [
          {
            question: 'How can I book a corporate cab in Pune with S9 Travels?',
            answer: 'Booking a corporate cab is quick and easy! You can book online via our website or app, or contact our customer service team for assistance with corporate bookings and arrangements.',
          },
          {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'We offer a range of vehicles for corporate travel, including premium sedans, SUVs, and spacious Innova cabs. Choose the vehicle that best suits your team’s needs.',
          },
          {
            question: 'Do you provide airport transfers for corporate clients?',
            answer: 'Yes, we provide reliable and timely airport transfers for corporate clients. Whether it’s a pickup or drop-off, we ensure a smooth and professional experience.',
          },
          {
            question: 'Can I book a corporate cab for long-distance travel?',
            answer: 'Absolutely! Our corporate cab service is available for both short and long-distance travel. Whether it’s a business trip or an event, we’ll ensure you get there comfortably and on time.',
          },
          {
            question: 'Are there any special rates for corporate bookings?',
            answer: 'Yes, we offer exclusive corporate rates for businesses. Contact us to discuss your company’s requirements and we’ll provide you with a tailored pricing plan.',
          },
          {
            question: 'Can I arrange for a corporate cab for multiple employees?',
            answer: 'Yes, we can accommodate bookings for multiple employees. Whether it’s a team outing, conference, or office event, we have a fleet of vehicles to suit any group size.',
          },
          {
            question: 'Are the drivers for corporate trips experienced and professional?',
            answer: 'Yes, all our drivers are highly trained, professional, and experienced in corporate travel. They ensure a safe, punctual, and pleasant journey for your business needs.',
          },
          {
            question: 'How do I ensure my corporate cab booking is tailored to my business needs?',
            answer: 'You can share your specific requirements with our customer service team, and we’ll customize your corporate cab service to match your schedule, vehicle preferences, and any other special requests.',
          },
          {
            question: 'Is there a cancellation policy for corporate cab bookings?',
            answer: 'Yes, we have a flexible cancellation policy. You can cancel your corporate cab booking within a specified time frame without any penalty. Please contact us for details.',
          },
          {
            question: 'Why should I choose S9 Travels for my corporate cab service in Pune?',
            answer: 'S9 Travels offers reliable, punctual, and comfortable corporate cab services with professional drivers and well-maintained vehicles. We provide an exceptional experience for all your business travel needs.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rajesh Kumar',
          designation: 'Business Executive',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels has been our go-to corporate cab service for the past year. Their punctuality, professionalism, and well-maintained vehicles have made business travel stress-free. Highly recommend for corporate trips!”',
        },
        {
          name: 'Mrs. Neha Mehta',
          designation: 'HR Manager',
          rating: [1, 1, 1, 1, 1],
          text: '“We’ve been using S9 Travels for our corporate transport needs, and the service is outstanding. The cabs are always on time, clean, and comfortable. The drivers are friendly and professional. Definitely a great choice for any business!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Corporate Cab Service in Pune",
        "description": "Book corporate cab services in Pune for businesses, including monthly services, corporate event transport, office cabs, and executive chauffeur services. S9 Travels offers affordable corporate transport solutions in Pune with reliable and timely services for your business travel and corporate group needs.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      

     
      
      
      


    return (
        <div>
        
        <Helmet>
        <title>Corporate Cab Service in Pune | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book corporate cab services in Pune for businesses, office transport, corporate events, and executive chauffeur services. Affordable and reliable transport solutions for business travel and group travel. Get the best fares for your corporate cab needs with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/43.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinpune;